import axiosClient from './axiosClient';
const BanDoDeXuatPhanBonApi = {
    getAll: () => {
        const url = '/bandodexuatphanbon/getall';
        return axiosClient.get(url)
    },

    delete: (str,gid,maloai) => {
        const url = '/bandodexuatphanbon/delete?str=' + str + '&&gid=' + gid + '&&maloai=' + maloai;
        console.log(url);
        return axiosClient.delete(url);
    },

    updateGeo: (data) =>{
        const url = '/bandodexuatphanbon/edit';
        return axiosClient.put(url, data);
    },

    addGeo: (data) =>{
        const url = '/bandodexuatphanbon/add';
        return axiosClient.post(url, data);
    },

    GetThongTin: (gid) => {
        const url = '/bandodexuatphanbon/getthongtin?Gid=' + gid;
        return axiosClient.get(url);
    },

    updateThongTin: (data) => {
        const url = '/bandodexuatphanbon/editthongtin';
        return axiosClient.put(url, data);
    },
    addThongTin: (data) => {
        const url = '/bandodexuatphanbon/addthongtin';
        return axiosClient.post(url, data);
    },
}
export default BanDoDeXuatPhanBonApi;